import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_RICH_PLACEMENT_MULTIANCHOR: TypedDocumentNode<Data, Variables> = gql`
  query getRichPlacementMultianchor($workspaceId: ID!) {
    workspaceRichPlacementMultianchorConfiguration(workspaceId: $workspaceId) {
      customStyling
      displayAfterUserInteractionEnabled
      fullWidthModeEnabled
      showCloseButtonEnabled
      singleAdViewTime
    }
  }
`
